export const convertCase = ({ value, mode = 'UPPER' }) => {
  const str = typeof value === 'string' ? value : value == null ? '' : String(value)

  switch (mode) {
    case 'UPPER':
      return str.toUpperCase()

    case 'LOWER':
      return str.toLowerCase()

    case 'CAPITALIZE': // hELLO wORLD -> Hello world
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

    case 'TITLE': // hello world -> Hello World
      return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())

    case 'SENTENCE': // hello world -> Hello world
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

    case 'CAMEL': // hello world -> helloWorld
      return str
        .replace(/[^a-zA-Z0-9]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
        .replace(/^(.)/, (c) => c.toLowerCase())

    case 'PASCAL': {
      // hello world -> HelloWorld
      const camel = str
        .replace(/[^a-zA-Z0-9]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
        .replace(/^(.)/, (c) => c.toLowerCase())
      return camel.charAt(0).toUpperCase() + camel.slice(1)
    }

    case 'KEBAB': // Hello World / helloWorld -> hello-world
      return str
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[^a-zA-Z0-9]+/g, '-')
        .toLowerCase()
        .replace(/^-+|-+$/g, '')

    default:
      return str
  }
}

export const roundNumber = (value, decimals = 2) => {
  const factor = 10 ** decimals
  return (Math.round(Number(value) * factor) / factor).toFixed(2)
}

export const createRipple = (event) => {
  const button = event.currentTarget

  // Remove existing ripple if any
  const existingRipple = button.querySelector('.ripple')
  if (existingRipple) {
    existingRipple.remove()
  }

  const ripple = document.createElement('span')
  const diameter = Math.max(button.clientWidth, button.clientHeight)
  const radius = diameter / 2

  ripple.style.width = ripple.style.height = `${diameter}px`
  ripple.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`
  ripple.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`
  ripple.classList.add('ripple')

  button.appendChild(ripple)
}
